import React from 'react';

const RestrictedLocation: React.FC = () => {
	return (
		<div className="center-center-content">
			<div className="online-booking__error-code-component">
				<div className="text">
					<p>We’re sorry. Online booking is currently not available in your area.</p>
					<p>
						Please call our Support Center to help finalize your booking
						{' '}
						<span className="inline-block">
							<a href="tel:+8559335683" className="inline-link">(855) 933-5683.</a>
						</span>
					</p>
					<p>Thank you for your patience!</p>
				</div>
			</div>
		</div>
	);
};

export default RestrictedLocation;
